<script lang="ts" setup>
export interface PagesOfficesDetailContactItemProps {
    link: string
    iconKey: string
    label: string
    note?: string
}

const props = defineProps<PagesOfficesDetailContactItemProps>()
const { data, sendEvent } = useTracker()

const handleClick = (): void => {
    sendEvent({
        data: {
            ...data,
            click: props.label,
        },
    })
}
</script>
<template>
  <li>
    <a
      :href="props.link"
      class="d-flex align-items-center fs-bigger"
      @click="handleClick"
    >
      <svg
        aria-hidden="true"
        class="d-block me-3 text-secondary"
        width="20"
        height="20"
      >
        <use :xlink:href="`#${props.iconKey}`" />
      </svg>
      {{ props.label }}
    </a>
    <div
      v-if="props.note"
      class="fs-small mt-1 ms-7"
    >
      {{ props.note }}
    </div>
  </li>
</template>
